import React from "react";
import { Flex } from "antd";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

import "./Tickets.scss";

const Banner = () => {
   return (
      <div
         className="tickets__banner-image"
         style={{
            background: `no-repeat right 40% / auto url(${toAbsoluteUrl(
               "/media/svg/survey/PreviewBanner.svg"
            )}), #D9E3FF`
         }}
      >
         <Flex
            align="center"
            style={{
               height: "100%"
            }}
         >
            <h2 className="tickets__banner-title">Ticket history</h2>
         </Flex>
      </div>
   );
};

export default Banner;
